module.exports = __webpack_public_path__ + "static/media/TOR.badf3590.svg";